import React, { useRef, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as API from "../api/request";

const Detail = () => {
  const myRef = useRef();
  const navigate = useNavigate();
  const { id } = useParams();
  const [list, setList] = useState([]);
  const [filter_list, setFilter_list] = useState([]);
  const [active, setActive] = useState(null);
  const [pdf_show, setPdf_show] = useState(false);

  useEffect(() => {
    API.getPublicData(id)
      .then((res) => {
        setList(res);
        if (res.length > 0) {
          setActive(res[0]?.id);
        }
      })
      .catch((err) => {
        Swal.fire("Анхаар", "Жагсаалт татаж чадсангүй!", "warning");
      });
  }, [id]);

  useEffect(() => {
    if (active && list.length > 0) {
      let find_data = list.find((el) => el.id === active);
      setFilter_list(find_data);
      if (find_data.attachments.length > 0) {
        if (find_data.attachments[0].attachment_extension === "pdf") {
          getFile(
            find_data.attachments[0].id,
            find_data.attachments[0].attachment_extension,
            find_data.attachments[0].attachment_url
          );
        } else {
          setPdf_show(false);
        }
      } else {
        setPdf_show(false);
      }
    }
  }, [active, list]);

  const getFile = (id, type, name) => {
    if (id) {
      API.getPublicAttachment(id)
        .then((res) => {
          const file = new Blob([res], {
            type: "application/pdf",
          });
          const obj_url = URL.createObjectURL(file);
          if (type === "pdf") {
            setPdf_show(true);
            setTimeout(() => {
              const iframesrc = document.getElementById("pdf_viewer");
              if (iframesrc) {
                iframesrc.contentWindow.location.replace(obj_url);
              }
            }, 500);
          } else {
            const link = document.createElement("a");
            link.href = obj_url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(() => {
          Swal.fire(
            "Анхаар",
            "Файлыг татаж чадсангүй дахин оролдоно уу!",
            "warning"
          );
        });
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-2">
      <div className="flex justify-between md:gap-4 flex-col md:flex-row shadow rounded">
        <div>
          <div
            className="group py-4 px-3 cursor-pointer text-base border-b duration-300 hover:bg-slate-50 border-r flex items-center gap-4"
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="p-1 bg-[#00947d] w-8 h-8 flex items-center justify-center rounded-full shadow-2xl group-hover:bg-[#007a68] group-hover:scale-105">
              <i className="fa fa-chevron-left text-white" />
            </div>
            <div className="uppercase font-semibold text-gray-600">Буцах</div>
          </div>
          <div className="flex flex-col w-full md:w-[320px] border-r h-[calc(100vh-200px)] scrollbar">
            {list.length > 0 &&
              list.map((el, index) => {
                return (
                  <div
                    className={`py-2 border-b px-2 cursor-pointer duration-300 hover:bg-blue-100 ${
                      active === el.id ? "bg-blue-100" : ""
                    }`}
                    key={index}
                    onClick={() => {
                      setActive(el.id);
                    }}
                  >
                    {el.data_name}
                  </div>
                );
              })}
          </div>
        </div>
        <div className="flex flex-col w-full gap-2">
          {filter_list.url && (
            <div
              className="pt-4 px-2 text-blue-500 underline cursor-pointer"
              onClick={() => {
                window.open(filter_list.url, "_blank");
              }}
            >
              {filter_list.url}
            </div>
          )}
          <div
            className={`w-full md:pl-0 flex flex-row gap-2 px-2 ${
              !filter_list.url && "pt-4"
            }`}
          >
            {filter_list?.attachments?.length > 0 &&
              filter_list?.attachments.map((el, index) => {
                return (
                  <div
                    key={index}
                    className={`px-4 py-2 h-10 rounded-md text-white duration-300 cursor-pointer hover:scale-105 ${
                      el.attachment_extension === "pdf"
                        ? "bg-red-600"
                        : el.attachment_extension === "docx"
                        ? "bg-blue-600"
                        : el.attachment_extension === "xlsx"
                        ? "bg-green-600"
                        : "bg-gray-600"
                    }`}
                    onClick={() => {
                      getFile(
                        el.id,
                        el.attachment_extension,
                        el.attachment_name
                      );
                    }}
                  >
                    {el.attachment_extension === "pdf" ? (
                      <i className="fa fa-file-pdf mr-2" />
                    ) : el.attachment_extension === "docx" ? (
                      <i className="fa fa-file-word mr-2" />
                    ) : el.attachment_extension === "xlsx" ? (
                      <i className="fa fa-file-excel mr-2" />
                    ) : (
                      <i className="fa fa-file mr-2" />
                    )}
                    {el.attachment_name}
                  </div>
                );
              })}
          </div>
          <div className="py-2 w-full">
            {pdf_show && (
              <iframe
                ref={myRef}
                title="PDF"
                frameBorder={0}
                id="pdf_viewer"
                className="w-full h-[calc(100vh-280px)]"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Detail);
